<template lang="">
  <div 
  v-if="$store.state.permissions.showWhizz"
  class="flex flex-row w-screen h-screen">
    <div class="w-full">
      <div
        class="lg:flex lg:items-center lg:justify-between my-4 lg:mx-12 mx-12"
      >
        <div class="flex justify-center lg:justify-start mt-4 min-w-0">
          <div>
            <h2
              class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
            >
              Search Name
            </h2>
          </div>
        </div>
      </div>
      <div class="flex flex-row w-full my-8 items-center justify-center">
        <div class="border-b-2 mx-2">
          <select v-model="documentType">
            <option value="lebanese_id">Lebanese ID</option>
            <option value="passport">Passport</option>
          </select>
        </div>

        <div>
          <ul
            class="items-center text-sm font-medium text-gray-900 bg-white rounded-lg sm:flex"
          >
            <div
              class="mt-4 gap-3 w-min flex flex-col justify-center md:flex-row lg:mt-0 lg:ml-4"
            >
              <button
                class="py-2 px-4 mt-2 mx-2 bg-woo rounded-lg text-white font-semibold"
                @click="search()"
              >
                Search
              </button>
            </div>
          </ul>
        </div>
      </div>
      <picture-input
        @change="onChange"
        :crop="false"
        width="400"
        height="400"
        accept="image/jpeg,image/png"
        size="10"
        button-class="btn"
      >
      </picture-input>

          <div  v-if="object" class="overflow-x-auto">
                <div v-if="object.status == 'success'" class="min-w-screen flex items-center justify-center  font-sans overflow-hidden">
                    <div class="w-full lg:w-5/6">
                        <div class="bg-white shadow-md rounded my-6">
                            <table class="min-w-max w-full table-auto">
                                <thead>
                                    <tr class="bg-gray-400 text-gray-800 uppercase text-sm leading-normal">
                                        <th class="py-3 px-6 text-center">Variable</th>
                                        <th class="py-3 px-6 text-center">English</th>
                                        <th class="py-3 px-6 text-center">Arabic</th>
                                        <th class="py-3 px-6 text-center">Score</th>

                                    </tr>
                                </thead>
                                <tbody class="text-gray-700 text-sm font-light">
                                    <tr v-bind:key="value" v-for="(key, value) in object.details" class="border-b border-gray-200 hover:bg-gray-100">
                                        <td class="py-3 px-6 text-left whitespace-nowrap">
                                            <div class="flex items-center justify-center">
                                                <span class="font-medium">{{convertText(value)}}</span>
                                            </div>
                                        </td>
                                        <td v-if="value != 'profilePicture'" class="py-3 px-6 text-left">
                                            <div class="flex items-center justify-center">
                                                <span>{{key.data}}</span>
                                            </div>
                                        </td>
                                        <td v-else class="py-3 px-6 text-left">
                                            <div class="flex items-center justify-center">
                                              <img v-bind:src="'data:image/png;base64,'+key.data"/>
                                            </div>
                                        </td>
                                        <td class="py-3 px-6 text-center">
                                            <div class="flex items-center justify-center">
                                              {{key.ar}}
                                            </div>
                                        <td class="py-3 px-6 text-center">
                                          <div class="flex items-center justify-center">
                                              {{key.score}}
                                          </div>
                                        </td>
                            
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
              </div>
              <div  v-if="object" class="overflow-x-auto">
                <div class="min-w-screen flex items-center justify-center  font-sans overflow-hidden">
                    <div class="w-full lg:w-5/6">
                        <div class="bg-white shadow-md rounded my-6">
                            <table class="min-w-max w-full table-auto">
                                <thead>
                                    <tr class="bg-gray-400 text-gray-800 uppercase text-sm leading-normal">
                                        <th class="py-3 px-6 text-center">Variable</th>
                                        <th class="py-3 px-6 text-center">Value</th>
                                    </tr>
                                </thead>
                                <tbody class="text-gray-700 text-sm font-light">
                                    <tr class="border-b border-gray-200 hover:bg-gray-100">
                                        <td class="py-3 px-6 text-center whitespace-nowrap">
                                            <div class="flex items-center justify-center">
                                              Total Server Time
                                            </div>
                                        </td>
                                        <td class="py-3 px-6 text-center whitespace-nowrap">
                                            <div class="flex items-center justify-center">
                                              {{object.totalServerTime}}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
              </div>
            </div>
            <div v-else>
              <span class="font-medium">Failed</span>
            </div>
       </div>
      </div>
    </div>
</template>
<script>
import Http, { OCR_ENDPOINTS } from "../request";
import PictureInput from "vue-picture-input";

export default {
  created() {
  },

  components: {
    PictureInput,
  },

  data() {
    return {
      image: null,
      documentType: "lebanese_id",
      results: null,
      object:null
    };
  },
  methods: {
    convertText(text){
      const result = text.replace(/([A-Z])/g, " $1");
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
    onChange(image) {
      if (image) {
        this.image = image;
      }
    },

    search() {
      let files = new FormData();
      files.append("files", this.convertBase64ToBlob(this.image));

      Http()
        .post(OCR_ENDPOINTS.ocr, files, {
          params: {
            documentType: this.documentType,
          },
        })
        .then((response) => {
          this.object = response.data[0];
        })
        .catch((error) => {
          console.log(error.message);
          this.$toast.error(error.message);
        })
        .finally(() => {});
    },

    convertBase64ToBlob(base64Image) {
      const parts = base64Image.split(";base64,");
      const imageType = parts[0].split(":")[1];
      const decodedData = window.atob(parts[1]);
      const uInt8Array = new Uint8Array(decodedData.length);
      for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: imageType });
    },
  },
};
</script>
<style>
.picture-preview{
  z-index: 1 !important;
}
</style>